import React, { useEffect, useState } from 'react';

const WhyChooseUs = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('why-choose-section');
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  return (
    <div id="why-choose-section" style={{
      padding: '40px 20px',
      maxWidth: '1200px',
      margin: '0 auto',
      textAlign: 'center'
    }}>
      {/* Main Heading Section */}
      <h2 style={{
        color: '#410684',
        fontFamily: '"Oswald", sans-serif',
        fontSize: '60px',
        lineHeight: '72px',
        fontWeight: 700,
        fontStyle: 'normal',
        marginBottom: '20px',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(-20px)',
        transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
      }}>
        WHY CHOOSE US
      </h2>
      
      {/* Description Text */}
      <p style={{
        color: 'rgb(65, 64, 66)',
        fontFamily: '"Inter", sans-serif',
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 400,
        fontStyle: 'normal',
        textAlign:'center',
        maxWidth: '910px',
        margin: '0 auto 40px',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.8s ease-out 0.2s, transform 0.8s ease-out 0.2s'
      }}>
        At Ejil Enterprise, we provide reliable, innovative solutions designed to enhance productivity and drive success. With our expertise and dedicated approach, we ensure your business excels in today's competitive digital world.
      </p>

      {/* Cards Container */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '30px',
        flexWrap: 'wrap'
      }}>
        {[
          {
            title: 'FULL-TIME SUPPORT',
            text: 'Our team is available around the clock, providing assistance whenever you need it. We prioritize your uptime, ensuring smooth operations and minimal disruptions.',
            delay: 0.4
          },
          {
            title: 'EXPERT SERVICES',
            text: 'With a skilled team of professionals, we offer customized solutions tailored to your specific needs. Our commitment to excellence empowers your business with reliable and effective strategies.',
            delay: 0.6
          },
          {
            title: 'TRUSTED QUALITY',
            text: 'We are committed to delivering high-quality service you can trust, backed by loyal clients worldwide. Through our global partnerships, we bring consistent and dependable support to every project.',
            delay: 0.8
          }
        ].map((card, index) => (
          <div key={index} style={{
            backgroundColor: '#F1F2F4',
            borderRadius: '10px',
            padding: '30px',
            flex: '1',
            minWidth: '300px',
            maxWidth: '350px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
            transitionDelay: `${card.delay}s`,
            textAlign: 'left'
          }}
          className="hover-card">
            <h3 style={{
              color: '#410684',
              fontFamily: '"Oswald", sans-serif',
              fontSize: '32px',
              lineHeight: '40px',
              fontWeight: 600,
              fontStyle: 'normal',
              marginBottom: '15px'
            }}>
              {card.title}
            </h3>
            <p style={{
              color: 'rgb(65, 64, 66)',
              fontFamily: '"Inter", sans-serif',
              fontSize: '14px',
              lineHeight: '20px',
              fontWeight: 400,
              fontStyle: 'normal',
              textAlign: 'justify'
            }}>
              {card.text}
            </p>
          </div>
        ))}
      </div>

      {/* Hover Effects */}
      <style>
        {`
          .hover-card:hover {
            transform: translateY(-10px) !important;
            box-shadow: 0 5px 15px rgba(0,0,0,0.1);
          }
        `}
      </style>
    </div>
  );
};

export default WhyChooseUs;